import { useEffect } from "react";
import { toast } from "sonner";
import { PageHeader } from "@/components/Common";
import { ChatThread } from "@/components/ChatThread";
import { api, formatErr, useFetch } from "@/lib/api";

export default function Messages() {
  const { data, setData, reload } = useFetch("/messages");
  useEffect(() => {
    const t = setInterval(reload, 5000);
    return () => clearInterval(t);
  }, [reload]);

  const send = async (body) => {
    try {
      const { data: m } = await api.post("/messages", { body });
      setData((prev) => [...(prev || []), m]);
    } catch (e) {
      toast.error(formatErr(e));
    }
  };

  return (
    <div>
      <PageHeader eyebrow="Concierge" title="Messages" desc="Chat directly with your recruitment team about roles, candidates or anything else." />
      <ChatThread messages={data} onSend={send} meRole="business" emptyText="Say hello — tell us about the role you're hiring for." />
    </div>
  );
}
